// extracted by mini-css-extract-plugin
module.exports = {"modal":"AlpModal_modal__1Yvoz","displayAlpFooter":"AlpModal_displayAlpFooter__gg8tX","alpImg":"AlpModal_alpImg__31wPn","alpWrapper":"AlpModal_alpWrapper__WCg6k"};